export const rating = {
  root: {
    gap: "{gap.8}",
    transitionDuration: "{transition.duration}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  icon: {
    size: "20px",
    color: "{text.input-icon}",
    hoverColor: "{primary.support}",
    activeColor: "{primary.support}",
  },
};
